import React, { useEffect, useState } from 'react'
import { Button, Card, Col, DatePicker, Flex, Input, message, Modal, Row, Space, Table, Tag } from 'antd';
import { Grid } from "@mui/material";
import { DeleteFilled, EditFilled, ExportOutlined, FilterOutlined, PlusCircleFilled, SearchOutlined, UpSquareOutlined, UpSquareTwoTone } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { showLoading, useLoadingDispatch, hideLoading } from '../../context/loadingContext';
import AuthService from '../../Components/auth/AuthService';
import moment from 'moment';
import { use } from 'react';
import { useSelector } from 'react-redux';
import { UpdateOutlined } from '@mui/icons-material';
import { showMessage } from '../../Components/Utils/message';
import { encodeId } from '../../Components/common/CommonFun';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();

const CycleCountList = () => {
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();
  const { products: allProducts } = useSelector((state) => state.AppState?.userCreds);
  const [cycleCounts, setCycleCounts] = useState([]);
  const today = dayjs().format('YYYY-MM-DD');
  const firstDayOfMonth = dayjs().startOf('month');
  const lastDayOfMonth = dayjs().endOf('month');

  const { RangePicker } = DatePicker
  const [filters, setFilters] = React.useState({
    dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
    batchCode: '',
  });

  const getInitialDates = () => {
    const saved = localStorage.getItem("cycleCountDateRange");
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.persistedDate === today) {
        return {
          start: dayjs(parsed.startDate),
          end: dayjs(parsed.endDate),
        };
      }
    }
    return {
      start: firstDayOfMonth,
      end: lastDayOfMonth,
    };
  };

  const initialDates = getInitialDates();
  const [startDate, setStartDate] = useState(initialDates.start);
  const [endDate, setEndDate] = useState(initialDates.end);

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)

    navigate(`/cycle-counts/${hasedID}`)
  };
  const handleupdate = (id) => {
    const hasedID = encodeId(id)

    navigate(`/cycle-counts/update/${hasedID}`)
  };

  const deleteCycleCount = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/cycle-count`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getCountCycles();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const CycleColumns = [
    {
      title: 'Code',
      render: (record) => {
        return (
          <span>
            {record?.cycle_count_code ? record?.cycle_count_code : ""}
          </span>
        )
      },
      // width: 135,
    },
    {
      title: 'Date',
      render: (record) => {
        return (
          <span>
            {dayjs(record.count_date).format("DD-MM-YYYY")}
          </span>
        )
      },
      // width: 135,
    },
    {
      title: 'Products',
      render(record) {
        return (
          <div>
            {
              record?.products?.map((product, index) => (
                <Tag style={{margin: 1}} color="blue" key={index}>
                  {`${product?.product_code} - ${product?.product_name}`}
                </Tag>
              ))
            }
          </div>
        )
      },
      width: 400
    },


    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <Flex gap={5} justify='end' onClick={(e) => e.stopPropagation()}>
            <ExportOutlined onClick={() => handleupdate(record.id)} style={{ fontSize: '25px', cursor: "pointer" }} />
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
            {
              !record?.posted_by > 0 && (
                <DeleteFilled style={
                  {
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                  }} onClick={() => {
                    Modal.confirm({
                      title: 'Delete Cycle Count',
                      centered: true,
                      content: `Are you sure to delete this Cycle Count?`,
                      onOk: () => deleteCycleCount(record.id),
                      okText: 'Delete',
                      cancelText: 'Cancel',
                      width: 600,
                      okButtonProps: { size: "large" },
                      cancelButtonProps: { size: "large" },
                    });
                  }}
                />
              )
            }

          </Flex>
        );
      },
    },
  ];

  const getCountCycles = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      //   limit: limit,
      //   page: page,
    }
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      dataToSend.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
      dataToSend.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
    }
    try {
      const res = await Auth.post(`/stock/cycle-counts`, dataToSend);
      if (res?.ack) {
        console.log(res?.cycle_counts);
        const data = res?.cycle_counts
        const combined = data.reduce((acc, item) => {
          const productInfo = allProducts.find(p => p.netsuite_id === item.product_netsuite_id);
          const productObj = { product_id: item.product_netsuite_id, product_name: productInfo?.name, product_code: productInfo?.code };
          const existing = acc.find(entry => entry.id === item.id);

          if (existing) {
            existing.products.push(productObj);
          } else {
            acc.push({
              id: item.id,
              count_date: item.count_date,
              posted_by: item.posted_by,
              status: item.status,
              cycle_count_code: item.cycle_count_code,
              products: [productObj],
            });
          }

          return acc;
        }, []);

        setCycleCounts(combined);
      } else {
        setCycleCounts([]);
        showMessage('error', res?.message || 'No cycle counts found for the selected date range');
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong while fetching cycle counts');
      setCycleCounts([]);

    }
    finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    getCountCycles();
  }, [filters?.dateRange]);

  console.log('cycleCounts', cycleCounts);



  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Cycle Counts</>}
        style={{ marginBottom: '10px' }}
        extra={
          <>
            <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF" }} onClick={() => navigate("/cycle-counts/new")} />
          </>
        }
      >
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={8}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates }))}
              format="DD-MM-YYYY"
              allowClear={false}
              
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
            <Input
              placeholder="Search"
              value={filters.batchCode}
              onChange={(e) => setFilters(prev => ({ ...prev, batchCode: e.target.value }))}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
              >
                Search
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
      <div >
        <Table
          dataSource={cycleCounts}
          columns={CycleColumns}
          pagination={false}
          bordered
          scroll={{ x: 'max-content'}}
          footer={() => `List of Cycle Counts - Total Records: ${cycleCounts?.length === 0 ? "0" : cycleCounts?.length}`}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
      </div>

    </DataSheet>
  )
}

export default CycleCountList
